module.exports = __webpack_public_path__ + "static/media/cityleft.bb27e268.webp";